import type { RouteRecordRaw } from 'vue-router';

import listRoute from './list';
import detailRoute from './update';
import createRoute from './create';

export default [listRoute, detailRoute, createRoute] as RouteRecordRaw[];
